import { useMutation } from '@tanstack/react-query'
import { loginUser } from '../index'

const useSignInAdmin = () =>
  useMutation({
    mutationFn: loginUser,
  })

export default useSignInAdmin
